module.exports = __webpack_public_path__ + "static/img/WATCH_GT1.a6a4b862.jpg";